import { useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../lib/useApi";
import { PageHeader, Card, Select, Spinner, EmptyState } from "../../components/ui";
import { StatusBadge } from "../../components/StatusBadge";
import { date, money, statusLabel } from "../../lib/format";
import { CASE_STATUS_LIST } from "../../lib/constants";
import type { CaseRow, Page } from "../../lib/types";

export function CrmCases() {
  const [status, setStatus] = useState("");
  const path = `/api/crm/cases?limit=100${status ? `&status=${status}` : ""}`;
  const { data, loading } = useApi<Page<CaseRow>>(path);
  const rows = data?.data ?? [];

  return (
    <>
      <PageHeader
        title="Expedientes"
        action={<Link to="/cases/new" className="btn btn-primary">Nuevo expediente</Link>}
      />
      <div className="mb-4 flex items-center gap-3">
        <Select value={status} onChange={(e) => setStatus(e.target.value)} className="max-w-xs">
          <option value="">Todos los estados</option>
          {CASE_STATUS_LIST.map((s) => (
            <option key={s} value={s}>{statusLabel(s)}</option>
          ))}
        </Select>
      </div>

      {loading ? (
        <Spinner />
      ) : rows.length === 0 ? (
        <EmptyState>No hay expedientes con este filtro.</EmptyState>
      ) : (
        <Card className="overflow-x-auto">
          <table className="w-full whitespace-nowrap text-sm">
            <thead className="border-b border-line text-left text-xs uppercase tracking-wide text-muted">
              <tr>
                <th className="px-5 py-3 font-medium">Referencia</th>
                <th className="px-5 py-3 font-medium">Estado</th>
                <th className="px-5 py-3 font-medium">País</th>
                <th className="px-5 py-3 font-medium">Importe</th>
                <th className="px-5 py-3 font-medium">Creado</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-line">
              {rows.map((c) => (
                <tr key={c.id} className="hover:bg-canvas">
                  <td className="px-5 py-3">
                    <Link to={`/cases/${c.id}`} className="font-mono font-medium text-accent-600 hover:underline">{c.publicRef}</Link>
                  </td>
                  <td className="px-5 py-3"><StatusBadge status={c.status} /></td>
                  <td className="px-5 py-3">{c.country}</td>
                  <td className="px-5 py-3 tnum">{money(c.priceMinor, c.currency ?? "EUR")}</td>
                  <td className="px-5 py-3 text-muted">{date(c.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </>
  );
}
